function enumToArray<EnumType extends {}>(enumerable: EnumType): (keyof EnumType)[] {
    // get all the members of the enum
    let enumMembers = (Object.keys(enumerable) as (keyof EnumType)[]).map((key) => enumerable[key]);

    // we are only interested in the numeric identifiers as these represent the values
    return enumMembers.filter((v) => typeof v !== 'number') as unknown as (keyof EnumType)[];
}

export default enumToArray;
